


import React, { useState, useEffect } from 'react';

const ClientShowcase = () => {
  // Your actual client logos
  const initialLogos = [
    { id: 1, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/eat%20&%20met.jfif?updatedAt=1750829944723', alt: 'Eat & Met' },
    { id: 2, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/ACE%20TECH.png?updatedAt=1750829944718', alt: 'ACE TECH' },
    { id: 3, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/ayurveda.jfif?updatedAt=1750829944595', alt: 'Ayurveda' },
    { id: 4, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/growork_logo.jfif?updatedAt=1750829944885', alt: 'Growork' },
    { id: 5, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/easy-chit.png?updatedAt=1750829945081', alt: 'Easy Chit' },
    { id: 6, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/bizz%20buzz.png?updatedAt=1750829945108', alt: 'Bizz Buzz' },
    { id: 7, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/kapil%20agro%20logo.png?updatedAt=1750829948715', alt: 'Kapil Agro' },
    { id: 8, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/HMTV_Channel_Logo.png?updatedAt=1750829948722', alt: 'HMTV' },
    { id: 9, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/kaushalya.png?updatedAt=1750829952666', alt: 'Kaushalya' },
    { id: 10, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/nigha.jfif?updatedAt=1750829953246', alt: 'Nigha' },
    { id: 11, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/vaktha.png?updatedAt=1750829956581', alt: 'Vaktha' },
    { id: 12, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/KapilFarms_logo.png?updatedAt=1750829952944', alt: 'Kapil Farms' },
    { id: 13, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/kdms_logo.jfif?updatedAt=1750829953020', alt: 'KDMS' },
    { id: 14, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/sankshema.jfif?updatedAt=1750829955035', alt: 'Sankshema' },
    { id: 15, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/taaza%20panta.png?updatedAt=1750829956490', alt: 'Taaza Panta' },
    { id: 16, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/kapil%20guru.jfif?updatedAt=1750829949562', alt: 'Kapil Guru' },
    { id: 17, src: 'https://ik.imagekit.io/kqumni8l2/KapilGroup%20logoes/Website/Kapil%20Business%20Park%20Logo.jfif?updatedAt=1750829948718', alt: 'Kapil Business Park' },
  ];

  const [currentSet, setCurrentSet] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Create multiple sets for smooth transitions
  const createLogoSets = () => {
    const shuffled = [...initialLogos].sort(() => Math.random() - 0.5);
    const sets = [];
    for (let i = 0; i < 3; i++) {
      sets.push([...shuffled].sort(() => Math.random() - 0.5));
    }
    return sets;
  };

  const [logoSets] = useState(createLogoSets());

  // Smooth logo set transitions every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSet((prev) => (prev + 1) % logoSets.length);
        setIsTransitioning(false);
      }, 500);
    }, 6000);

    return () => clearInterval(interval);
  }, [logoSets.length]);

  return (
    <div 
      className="w-full py-2 px-2 min-h-screen relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%)'
      }}
    >
      {/* Subtle Background Pattern */}
      <div 
        className="absolute inset-0 "
        style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(59, 130, 246, 0.1) 1px, transparent 0)`,
          backgroundSize: '30px 30px'
        }}
      />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header Section */}
  
        <div className="text-center px-2 sm:px-4 lg:px-8 mb-10">
      <h2 className="text-xl md:text-2xl lg:text-3xl  tracking-tight mb-2 ">
            <span
              className='text-xl md:text-2xl lg:text-3xl text-[#1f0158]' 
              
           >
         Powering the Future of Global Business
        </span>
        
      </h2>

      <div className="flex justify-center mb-6">
        <div
          className="h-1.5 rounded-full w-48 sm:w-72 lg:w-96"
          style={{
            background:
              "linear-gradient(90deg, #2563eb, #4f46e5, #7c3aed, #059669)",
          }}
        />
      </div>

      <p className="text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed font-medium text-[#17134f] mb-6">
        <span className="text-[#2563eb] font-bold">60+ Industry Leaders</span> rely on our expertise in
        digital innovation. From global enterprises to emerging startups, we
        craft <span className="text-[#059669] font-semibold">scalable software solutions</span> that accelerate growth.
      </p>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-5 text-base sm:text-lg">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-[#2563eb]"></div>
          <span className="text-[#475569] font-medium">Trusted Partnerships</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-[#059669]"></div>
          <span className="text-[#475569] font-medium">Proven Results</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-[#7c3aed]"></div>
          <span className="text-[#475569] font-medium">Global Impact</span>
        </div>
      </div>
    </div>



        <div className="relative">
          <div 
            className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-8 transition-all duration-500 ${
              isTransitioning ? 'opacity-0 transform scale-95' : 'opacity-100 transform scale-100'
            }`}
            style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.8) 100%)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(226,232,240,0.3)',
              boxShadow: '0 25px 50px rgba(0,0,0,0.05)',
              borderRadius: '24px',
              padding: '48px'
            }}
          >
            {logoSets[currentSet]?.map((logo, index) => (
              <div
                key={`${logo.id}-${currentSet}`}
                className="group relative flex items-center justify-center"
                style={{
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <div 
                  className="relative rounded-xl transition-all duration-300 p-6 flex items-center justify-center overflow-hidden group-hover:scale-105 group-hover:shadow-lg"
                  style={{
                    background: '#ffffff',
                    width: '180px',
                    height: '120px',
                   
                  }}
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="max-w-full max-h-full object-contain transition-all duration-300 group-hover:scale-110"
                    loading="lazy"
                   
                  />
                  
                  {/* Subtle Hover Overlay */}
                  <div 
                    className="absolute inset-0 bg-gradient-to-tr from-blue-50 to-purple-50 opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-xl"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Dots */}
          <div className="flex justify-center mt-6 space-x-1">
            {logoSets.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  setIsTransitioning(true);
                  setTimeout(() => {
                    setCurrentSet(index);
                    setIsTransitioning(false);
                  }, 250);
                }}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  currentSet === index 
                    ? 'bg-blue-600 scale-125' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { 
            opacity: 0; 
            transform: translateY(20px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }
        
        .grid > div {
          animation: fadeIn 0.6s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default ClientShowcase;
